import { AppState } from "../../../redux-configuration/AppState";
import { CityHeader } from "../../domain/entity/cityHeader";

export const searchedCitiesSelector = (state: AppState): CityHeader[] | null => state.registration.searchCity.cities
export const searchCityLoadingSelector = (state: AppState): boolean => state.registration.searchCity.loading
export const searchCityErrorSelector = (state: AppState): string | undefined => state.registration.searchCity.error
